var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-clock-7084715") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-5",
    transform: "translate(-104, -780)",
    fill: "#00467D",
    fillRule: "nonzero",
    stroke: "#00467D",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-clock-7084715",
    transform: "translate(105, 781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C3.58800705,0 0,3.58894768 0,8 C0,12.4119929 3.58800705,16 8,16 C12.4119929,16 16,12.4110523 16,8 C16,3.58800705 12.4119929,0 8,0 L8,0 Z M8,14.5888301 C4.36707819,14.5888301 1.41093474,11.6329218 1.41093474,7.99976484 C1.41093474,4.36660788 4.36684303,1.41069959 8,1.41069959 C11.633157,1.41069959 14.5890653,4.36660788 14.5890653,7.99976484 C14.5890653,11.6329218 11.633157,14.5888301 8,14.5888301 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.56260173 4 7 4 7 9 11 9 11 7.45599588 8.56249756 7.45599588"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconBlue);
export default __webpack_public_path__ + "static/media/clock-icon--blue.9f6b735232b4b14d15ee628133a0aad4.svg";
export { ForwardRef as ReactComponent };